import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-rounded-button',
  standalone: true,
  templateUrl: './rounded-button.component.html',
  styleUrls: ['./rounded-button.component.scss']
})
export class RoundedButtonComponent {
  @Input() label: string | undefined;
  @Input() btnClass: string | undefined;
  @Input() isDisabled: boolean | undefined;
  @Output() onClick = new EventEmitter<any>();

  onClickButton(event: Event): void {
    this.onClick.emit(event);
  }
}
